import { useRef, useState } from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';
import Input from '../Base';

const EditInput = ({ name = '', onChange = (_) => _ }) => {

  const [openInput, setInput] = useState(false);

  const save = (v) => {
    setInput(false);
    onChange(v);
  };
  const ref = useRef(null);

  return openInput ? (
    <Input
      value={name}
      style={{ width: '100%' }}
      onClickEnter={(v) => save(v)}
      onBlur={(v) => save(v)}
      autoFocus={true}
      ref={ref}
      className={styles.input_name}
    />
  ) : (
    <div onClick={() => setInput(true)} className={cn(styles.name, name.length === 0 && styles.name_empty)}>
      {name}
    </div>
  );
};

export default EditInput;
